<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-s-tools"></i>支付相关</el-breadcrumb-item>
      
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div>
                <AliPayControl></AliPayControl>
            </div>
        </div>
    </div>
</template>

<script>
import AliPayControl from './AliPayControl.vue'
export default {
    name: 'Gameconsole',
    components: {
        AliPayControl
    },
    data: function(){
        return {
            query: {
                projectName: ''  //项目名
            },
            //项目集合
            projects: [{
                cnName: "火星",
                name: "MARSPARK",
                objectId: "614e945bec1d407bb203ceb3"
            }]  
        };
    },
    created(){
     
    },
    activated(){
      
    },
    methods: {

    }
}
</script>